import React from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import SyncSelect from 'react-select';

const SingleValueFilter = props => {
  return props.isAsync ? <AsyncSelect {...props} /> : <SyncSelect {...props} />;
};

SingleValueFilter.propTypes = {
  isAsync: PropTypes.bool
};

SingleValueFilter.defaultProps = {
  isAsync: false
};

export default SingleValueFilter;
